import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AddBanner from './AddBanner';
// import Student from '../../../pages/User';
import BannerTable from './BannerTable';
import AddYoutube from './AddYoutbe';
import YoutubeTable from './YoutubeTable';
import { useTheme } from '@emotion/react';
import { Divider } from '@mui/material';
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const Youtube = () => {
    const access = JSON.parse(localStorage.getItem('detailObject')) || {};
    const role = localStorage.getItem('role') || '';
    const accessToContent = access?.accessToContent || [];
    const [value, setValue] = React.useState(() => {
        if (role == 'Admin') return 0;
        if (accessToContent?.includes("Demo Videos")) return 0;
        if (accessToContent?.includes("Add Demo Videos")) return 1;
        return 0;
    });


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant='h3' mb={3} >Manage Videos</Typography>
            <Divider />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ width: '100%', }}>
                    {(role === 'Admin' || accessToContent.includes('Demo Videos')) && (
                        <Tab value={0} label="All Videos" sx={{ width: '100%' }} {...a11yProps(0)} />
                    )}
                    {(role === 'Admin' || accessToContent.includes('Add Demo Videos')) && (
                        <Tab value={1} label="Add Video" sx={{ width: '100%' }} {...a11yProps(1)} />
                    )}
                </Tabs>
            </Box>
            {(role === 'Admin' || accessToContent.includes('Demo Videos')) && (
                <TabPanel value={value} index={0}>
                    <YoutubeTable />
                </TabPanel>
            )}
            {(role === 'Admin' || accessToContent.includes('Add Demo Videos')) && (
                <TabPanel value={value} index={1}>
                    <AddYoutube />
                </TabPanel>
            )}

        </Box >
    );
}

export default Youtube